import env from '@/config/env'
import request from '@/router/axios'

/**
 * 用户中心
 */

// 获取乘客列表信息
export const getUserInfoPage = (data) => {
  return request({
    url: `${env.ferryUrl}/user/info/page`,
    method: 'POST',
    data
  })
}

// 根据手机号获取用户信息
export const getUserInfoByPhone = (data) => {
  return request({
    url: `${env.ferryUrl}/user/info/total/${data}`,
    method: 'GET'
  })
}

// 给用户打标
export const addTag = (data) => {
  return request({
    url: `${env.ferryUrl}/user/info/addTag`,
    method: 'POST',
    data
  })
}

// 批量打标
export const addTagBatch = (data) => {
  return request({
    url: `${env.ferryUrl}/user/info/addTag/batch`,
    method: 'POST',
    data
  })
}

// 发放积分
export const addScore = (data) => {
  return request({
    url: `${env.ferryUrl}/user/info/addScore`,
    method: 'POST',
    data
  })
}

// 获取积分、成长值明细列表
export const getStatisticsPage = (data) => {
  return request({
    url: `${env.ferryUrl}/user/info/member/detail`,
    method: 'POST',
    data
  })
}

// 获取乘客已有标签
export const getUserTag = (data) => {
  return request({
    url: `${env.ferryUrl}/user/info/tag?userId=${data}`,
    method: 'GET'
  })
}
